module.exports = __webpack_public_path__ + "img/Endlich.5c777084.jpg";